import { useVideoIconStatus } from './video-icon-status.model'
import type { IVideoIconStatus } from './video-icon-status.types'
import { VideoIconStatusView } from './video-icon-status.view'

export const VideoIconStatus = ({ statusPost, postUrl }: IVideoIconStatus) => {
  const videoIconStatusModel = useVideoIconStatus({ statusPost, postUrl })

  return <VideoIconStatusView {...videoIconStatusModel} />
}
